import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import { Claims } from '../Models/Claims';
import {
  CircularProgress
} from '@mui/material';
import { useAPIContext } from '../Context/APIContext';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu() {
  const [loading, setLoading] = useState<boolean>(false);
  const [claims, setClaims] = useState<Claims>();
  const { apiFetch } = useAPIContext();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); 

      var claims = await apiFetch<Claims>('Auth/Claims', 'GET', Claims.fromJson);
      if (claims) {
        setClaims(claims);
      }

      setLoading(false);
    };

    fetchData();
  }, [apiFetch]);

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: (theme) => theme.palette.grey[50], // Light grey
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 0.5,
        }}
      >
        <Box
          component="img"
          src="/OPALITE LEARNING LOGO COLOR no tag-05.png"
          alt="Opalite Logo"
          sx={{ width: '100%' }}
        />
      </Box>

      <Divider />
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MenuContent />
      </Box>
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        {(loading) ? (
          <center>
            <CircularProgress style={{ color: '#3D9BE9' }} />
          </center>
        ) : (
          <>
            <Avatar
              sizes="small"
              alt={`${claims?.givenName} ${claims?.surname}`}
              src="/static/images/avatar/7.jpg"
              sx={{ width: 36, height: 36 }}
            />
            <Box sx={{ mr: 'auto', overflow: 'hidden' }}>
              <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
                {claims?.givenName} {claims?.surname}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {claims?.emailAddress}
              </Typography>
            </Box>
          </>
        )}
      </Stack>
    </Drawer>
  );
}
